import StorageObject from 'ember-local-storage/local/object';

const Storage = StorageObject.extend();

Storage.reopenClass({
  initialState() {
    return {
      // Per-classgroup visible column names keyed by classGroupId
      visibleColumns: {}
    };
  }
});

export default Storage;
